import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiTerapieDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoTerapie({ tenantId: currentTenant.Id, assistitoId: assistitoId });
          },
    
          byKey: (key) => {
            return api.getAssistitoTerapiaById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                terapiaId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoTerapia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoTerapiaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoTerapia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                terapiaId: key,
                assistitoTerapiaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoTerapia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                terapiaId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


